import { render, staticRenderFns } from "./MenuItemMobile.vue?vue&type=template&id=016359a1&scoped=true"
import script from "./MenuItemMobile.vue?vue&type=script&lang=js"
export * from "./MenuItemMobile.vue?vue&type=script&lang=js"
import style0 from "./MenuItemMobile.vue?vue&type=style&index=0&id=016359a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016359a1",
  null
  
)

export default component.exports